import React, { useState, useEffect } from "react";
//Material Ui
import {
  Container,
  MobileStepper,
  Button,
  Paper,
  Typography,
  useTheme,
  Grid,
  SvgIcon,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import WarningIcon from "@material-ui/icons/Warning";
//Components
import DialogCrop from "../../DialogCrop/DialogCrop";
import DialogTrips from "../../Dialog/Dialog";
import CustomDialog from "../../CustomDialog/CustomDialog";
import Pdf from "../../Pdf/Pdf";
import Alert from "../../Alert/Alert";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { ReactComponent as QRCode } from "../../../images/qr-code.svg";
import { ReactComponent as GoogleMaps } from "../../../images/google-maps.svg";
//Librerias
import moment from "moment-timezone";
import iphone_photo_rotation_adjust from "../../../utils/CustomRotation";
//Redux
import { fetchRequest, reset } from "../../../redux/actions/fetch/fetchActions";
import { useSelector, useDispatch } from "react-redux";
//Utils and Css
import "./loads.css";
import { text } from "../../../utils/Multilanguage";
import { useStyle } from "./useStyle";
import config from "../../../config";
import getCurrentPositionAsync from '../../../utils/Geolocation';

export default function Loads(props) {
  //Props
  const { data, step, setErrorResponse } = props;
  //Redux
  const dispatch = useDispatch();
  const fetch = useSelector((state) => state.fetch);
  //Librerias de Material Ui
  const classes = useStyle();
  const theme = useTheme();
  //Hooks
  const [activeStep, setActiveStep] = useState(step);
  const [typeload, setTypeLoad] = useState(1);
  const [errorSnackbar, setErrorSnackbar] = useState({
    isOpen: false,
    message: "Error",
  });
  const [isOpen, setIsOpen] = useState(false);
  const [imageDataUrl, setImageDataUrl] = useState(null);
  const [openQuestionDialog, setOpenQuestionDialog] = useState(false);
  const [pdfDialog, setPdfDialog] = useState(false);
  const [pdfName, setPdfName] = useState("");

  //UseEffect
  useEffect(() => {
    setActiveStep(+localStorage.getItem("STEP"));
  }, [data]);


  //Funciones
  const handleClosePdfDialog = () => {
    setPdfDialog(false);
  };

  const redirectToMap = (type, data) => {

    var lat = type === 1 ? data.locationFromLatitude : data.locationToLatitude;
    var lng = type === 1 ? data.locationFromLongitude : data.locationToLongitude;

    if (('standalone' in window.navigator) && window.navigator.standalone) {
      var win = window.open("https://maps.google.com/?q=" + lat + "," + lng + "", '_top');
      win.focus();
    } else {
      var win = window.open("https://maps.google.com/?q=" + lat + "," + lng + "", '_blank');
      win.focus();
    }
  };

  const onCloseDestinationWrong = () => {
    setOpenQuestionDialog(false);
  };

  const onTtime_in = async (tipo) => {
    let dataSend = null;
    const { latitude, longitude } = await getCurrentPositionAsync();


    if (tipo === 1) {
      if (data[activeStep].shipperIn === null) {
        dataSend = {
          tripId: data[activeStep].id,
          checkIn: moment.tz(new Date(), "America/Chicago").format("YYYY-MM-DD HH:mm:ss"),
          type: "SHIPPER",
          lat: latitude,
          lng: longitude
        };
      }
    } else if (tipo === 2) {
      if (data[activeStep].consigneeIn === null && data[activeStep].shipperOut !== null) {
        dataSend = {
          tripId: data[activeStep].id,
          checkIn: moment.tz(new Date(), "America/Chicago").format("YYYY-MM-DD HH:mm:ss"),
          type: "CONSIGNEE",
          lat: latitude,
          lng: longitude
        };
      } else {
        setErrorSnackbar({
          message: "Must enter PU Out first!",
          isOpen: true,
        });
      }
    } else {
      if (data[activeStep].shipperOut === null && data[activeStep].shipperIn !== null) {
        dataSend = {
          tripId: data[activeStep].id,
          checkIn: moment.tz(new Date(), "America/Chicago").format("YYYY-MM-DD HH:mm:ss"),
          type: "SHIPPER_OUT",
          lat: latitude,
          lng: longitude
        };
      } else {
        setErrorSnackbar({
          message: "Must enter PU In first!",
          isOpen: true,
        });
      }
    }

    if (dataSend !== null) {
      var token = localStorage.getItem("token");
      var authKey = localStorage.getItem("key");



      dispatch(
        fetchRequest(
          `${config.API_URL}services/app/Trip/UpdateCheckIn?key=${authKey}`,
          dataSend,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "Abp.Tenantid": config.TENANT_ID
            },
          },
          "POST"
        )
      );
    }
  };

  if (data) {
    if (data.length > 0) {
      const maxSteps = data.length;

      const handleNext = () => {
        localStorage.setItem("STEP", activeStep + 1);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };

      const handleBack = () => {
        localStorage.setItem("STEP", activeStep - 1);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };

      const handleClose = (event, reason) => {
        if (reason === "timeout") {
          setErrorSnackbar({ ...errorSnackbar, isOpen: false });
        }
      };

      const handleTicketpickup = (type) => {
        dispatch(reset());
        if (data[activeStep].locationToUrlFile !== null) {
          setPdfName(data[activeStep].locationToUrlFile);
          setPdfDialog(true);
        } else {
          if (data[activeStep].consigneeIn === null) {
            setErrorSnackbar({
              message: "Must enter DEL In first!",
              isOpen: true,
            });
          } else {
            setTypeLoad(type);
            document.getElementById("icon-button-file").click();
          }
        }
      };

      const onFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
          const file = e.target.files[0];

          iphone_photo_rotation_adjust(file).then((result) => {
            setImageDataUrl(result);
            setIsOpen(true);
          });
        }
      };

      const handleCloseDialog = () => {
        setIsOpen(false);
        setImageDataUrl(null);
      };

      if (activeStep > data.length) {
        return "";
      } else {
        return (
          <Container
            style={{
              position: "fixed",
              height: "90%",
              paddingLeft: "0px",
              paddingRight: "0px",
              overflowY: "auto",
            }}
          >
            <div className={classes.root}>
              <LoadingSpinner isLoading={fetch.loading} />
              <MobileStepper
                steps={maxSteps}
                position='static'
                variant='text'
                activeStep={activeStep}
                nextButton={
                  <Button
                    size='medium'
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    {theme.direction === "rtl" ? (
                      <ArrowBackIcon />
                    ) : (
                      <ArrowForwardIcon />
                    )}
                  </Button>
                }
                backButton={
                  <Button
                    size='large'
                    onClick={handleBack}
                    disabled={activeStep === 0}
                  >
                    {theme.direction === "rtl" ? (
                      <ArrowForwardIcon />
                    ) : (
                      <ArrowBackIcon />
                    )}
                  </Button>
                }
              />
              <Paper square elevation={0} className={classes.header}>
                <Typography variant='h5'>
                  {text("Trip")} #{activeStep + 1}{" "}
                </Typography>
                <Typography variant='h6'>
                  {data[activeStep].material}
                </Typography>
                <Typography variant='h6'>
                  Pickup Under: {data[activeStep].pickUpUnder}
                </Typography>
                {data[activeStep].rejected && (
                  <Typography variant='h6' style={{ color: "red" }} >
                    Trip Rejected
                  </Typography>
                )}
              </Paper>
              <br />
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Paper
                    className={
                      data[activeStep].pickup_address_wrong === "1"
                        ? classes.headerpickupWrong
                        : classes.headerpickup
                    }
                    elevation={0}
                  >
                    {data[activeStep].pickup_address_wrong === "1" && (
                      <WarningIcon style={{ color: "#ffb300" }} />
                    )}
                    <Typography variant='body1'>
                      {data[activeStep].locationFromName}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerpickup}
                    elevation={0}
                  >
                    <Typography variant='body1'>
                      {data[activeStep].locationFromAddress}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerpickup}
                    elevation={0}
                    onClick={() => {
                      redirectToMap(1, data[activeStep]);
                    }}
                  >
                    <Typography variant='body1'>
                      {data[activeStep].locationFromCode}
                      <br />
                      <SvgIcon
                        component={GoogleMaps}
                      />
                      {/* <i
                        className='material-icons center'
                        style={{
                          fontSize: "30px",
                          position: "relative",
                          top: "-2px",
                        }}
                      >
                        map
                      </i> */}
                    </Typography>

                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper
                    className={
                      data[activeStep].delivery_address_wrong === "1"
                        ? classes.headerpickupWrong
                        : classes.headerdelivery
                    }
                    style={{ backgroundColor: "#e8f5e9" }}
                    elevation={0}
                  >
                    {data[activeStep].delivery_address_wrong === "1" && (
                      <WarningIcon
                        style={{ color: "#ffb300", marginLeft: "5px" }}
                      />
                    )}
                    <Typography variant='body1' style={{ width: "100%" }}>
                      {data[activeStep].locationToName}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerdelivery}
                    elevation={0}
                  >
                    <Typography variant='body1'>
                      {data[activeStep].locationToAddress}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerdelivery}
                    elevation={0}
                    onClick={() => {
                      redirectToMap(2, data[activeStep]);
                    }}
                  >
                    <Typography variant='body1'>
                      {data[activeStep].locationToCode}
                      <br />
                      <SvgIcon
                        component={GoogleMaps}
                      />
                    </Typography>
                  </Paper>

                </Grid>
                <Grid item xs={12}>
                  {data[activeStep].notes !== "" && (
                    <Paper
                      style={{
                        backgroundColor: "#d4e157",
                        border: "1px solid",
                        alignItems: "center",
                        color: "black",
                      }}
                    >
                      {data[activeStep].notes?.split("\\n").map((item, key) => {
                        return (
                          <span
                            key={key}
                            style={{ marginLeft: "10px", fontSize: "15px" }}
                          >
                            {item}
                            <br />
                          </span>
                        );
                      })}
                    </Paper>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.headerpickup} elevation={0}>
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].ticketShipperNumber !== null &&
                        data[activeStep].ticketShipperNumber !== "" &&
                        data[activeStep].ticketShipperNumber !== " "
                        ? data[activeStep].ticketShipperNumber
                        : "Ticket #..."}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerpickup} elevation={0}>
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].shipperTons !== null &&
                        data[activeStep].shipperTons > 0
                        ? data[activeStep].shipperTons
                        : `${text("Tonnage")}...`}
                    </Typography>
                  </Paper>
                  <br />
                  <Paper
                    className={classes.headerpickup}
                    elevation={0}
                    onClick={() => {
                      onTtime_in(1);
                    }}
                  >
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].shipperIn !== null
                        ? moment.utc(data[activeStep].shipperIn).format(
                          "HH:mm:ss"
                        )
                        : text("Check in time")}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerpickup}
                    elevation={0}
                    onClick={() => {
                      onTtime_in(3);
                    }}
                  >
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].shipperOut !== null
                        ? moment.utc(data[activeStep].shipperOut).format(
                          "HH:mm:ss"
                        )
                        : text("Departure time")}
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.headerdelivery} elevation={0}>
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].ticketConsigneeNumber !== "" &&
                        data[activeStep].ticketConsigneeNumber !== " " &&
                        data[activeStep].ticketConsigneeNumber !== null
                        ? data[activeStep].ticketConsigneeNumber
                        : "Ticket #..."}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerdelivery} elevation={0}>
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].consigneeTons !== null &&
                        data[activeStep].consigneeTons > 0
                        ? data[activeStep].consigneeTons
                        : `${text("Tonnage")}...`}
                    </Typography>
                  </Paper>
                  <br />
                  <Paper
                    className={classes.headerdelivery}
                    elevation={0}
                    onClick={() => {
                      onTtime_in(2);
                    }}
                  >
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].consigneeIn !== null
                        ? moment.utc(data[activeStep].consigneeIn).format(
                          "HH:mm:ss"
                        )
                        : text("Check in time")}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerdelivery} elevation={0}>
                    <Typography variant='body1' className={classes.text}>
                      {data[activeStep].consigneeOut !== null
                        ? moment.utc(data[activeStep].consigneeOut).format(
                          "HH:mm:ss"
                        )
                        : text("Departure time")}
                    </Typography>
                  </Paper>


                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12}>
                  <input
                    type='file'
                    capture='camera'
                    accept='image/*'
                    id='icon-button-file'
                    name='uploadPhotoInput'
                    hidden
                    onChange={onFileChange}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                  />
                  <Paper
                    className={classes.headerdelivery}
                    elevation={0}
                    onClick={() => {
                      handleTicketpickup(2);
                    }}
                  >
                    <Typography
                      variant='body1'
                      className={
                        data[activeStep].locationToUrlFile !== null
                          ? classes.viewTicket
                          : classes.textButton
                      }
                    >
                      {data[activeStep].locationToUrlFile !== null
                        ? text("View Ticket")
                        : text("Upload Ticket")}
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper
                    elevation={0}
                    style={{
                      height: "90px",
                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <SvgIcon
                      component={QRCode}
                      viewBox='0 0 1000 1000'
                      style={{ width: "100%", height: "90%" }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper
                    elevation={0}
                    style={{
                      height: "90px",
                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <SvgIcon
                      component={QRCode}
                      viewBox='0 0 1000 1000'
                      style={{ width: "100%", height: "90%" }}
                    />
                  </Paper>
                </Grid>

              </Grid>
            </div>
            <Alert
              isOpen={errorSnackbar.isOpen}
              handleClose={handleClose}
              text={text(errorSnackbar.message)}
            />

            <DialogCrop
              imageDataUrl={imageDataUrl}
              isOpen={isOpen}
              handleClose={handleCloseDialog}
              load={data[activeStep]}
              typeload={typeload}
            />
            <DialogTrips
              open={openQuestionDialog}
              onClose={onCloseDestinationWrong}
              title={text("Warning")}
              question={text("Report wrong destination?")}
              load_id={data[activeStep].load_id}
              type={typeload}
              dispatch={dispatch}
              fetchRequest={fetchRequest}
            />
            <CustomDialog
              isOpen={pdfDialog}
              handleClose={handleClosePdfDialog}
              title='Pdf Ticket'
              childrenElement={
                <Pdf
                  handleClose={handleClosePdfDialog}
                  data={{
                    url: pdfName,
                  }}
                />
              }
              showCancelButton={true}
            />
          </Container>
        );
      }
    } else {
      return (
        <Container
          style={{
            position: "fixed",
            height: "100%",
            paddingLeft: "0px",
            paddingRight: "0px",
            display: "grid",
            textAlign: "center",
          }}
        >
          <Typography variant='subtitle1'>{text("Has no trips")}</Typography>
        </Container>
      );
    }
  } else {
    return "";
  }
}
